export enum Lang{
  UZ = "UZ",
  RU = "RU",
  EN = "EN"
}
